'use strict';

wbApp.directive('wbUserLookup', ['$http', '$translate', '$timeout', '$filter', 'userSvc',
    function ($http, $translate, $timeout, $filter, userSvc) {
        function formatResult(model) {
            if (!model) { return; }

            return "<div class='row'>" +
                        "<div class='col-md-4'>" + model.fullName + "</div>" +
                        "<div class='col-md-5'>" + model.email + "</div>" +
                        "<div class='col-md-3'>" + $filter('phone')(model.phone) + "</div>" +
                    "</div>";
        }

        function formatSelection(model) {
            return model.fullName;
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attrs, controller) {

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_USER'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: !attrs.required,
                        ajax: {
                            url: "Api/Users/GetLookupQuery",
                            data: function (term, page) {
                                return {
                                    query: term,
                                    pageSize: 10,
                                    pageNo: page,
                                };
                            },
                            results: function (data, page) {
                                var more = data.length > 0;
                                return { results: data, more: more };
                            }
                        },
                        initSelection: function (element, callback) {
                            var id = $(element).val();
                            if (!!id && id != "undefined") {
                                $http({
                                    method: 'GET',
                                    url: "Api/Users/GetLookupID",
                                    params: { userID: id }
                                })
                                .success(function (data, status, headers, config) {
                                    controller.$setViewValue(data.id);
                                    callback(data);
                                });
                            }
                        }
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    //elm.on('change', function () {
                    //    scope.$apply(function () {
                    //        controller.$setViewValue(elm.select2('val'));
                    //    });
                    //});

                    //attrs.$observe('disabled', function (value) {
                    //    elm.select2('enable', !value);
                    //});

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                }, 1);

            }
        }
}]);
